var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTzAppLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 349 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 36.2175L0 11.8051L20.0283 0L40.1697 11.8051L60.9901 0L80 11.8051L40 36.2175Z",
    fill: "#0084F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.999 36.1026V82.6352L59.8291 71.174V47.4492L79.8857 36.1026V11.6902L39.999 36.1026Z",
    fill: "#2F9FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.999 36.1026V82.6352L20.169 71.174V47.4492L0.112335 36.1026V11.6902L39.999 36.1026Z",
    fill: "#005EAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.32 61V32.008H106.48V25.624H133.696V32.008H123.808V61H116.32Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.949 61L134.622 55.672V41.272L139.949 35.944H152.717L158.094 41.272V50.68H142.014V53.56L143.934 55.48L157.661 55.432V61H139.949ZM141.965 45.832H151.085V42.568L149.165 40.648L143.934 40.696L141.965 42.568V45.832Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M166.754 61V35.896H174.146V40.072L178.514 35.944H183.842V42.856H177.41L174.146 45.976V61H166.754Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190.06 61V35.896H197.452V40.072L201.82 35.944H207.148V42.856H200.716L197.452 45.976V61H190.06Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M215.467 61L210.139 55.672V50.296L215.467 44.968H227.515V43.048L225.595 41.128H213.307V35.944H229.579L234.907 41.272V61H227.515V57.448L224.011 61H215.467ZM219.403 56.296H222.955L227.515 51.736V49.432H219.403L217.483 51.304L217.531 54.424L219.403 56.296Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M243.8 61V56.584L262.856 30.712V29.656H244.808V25.624H268.52V30.04L249.512 55.912V56.968H268.712V61H243.8Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M279.784 61L274.744 55.96V40.936L279.784 35.896H290.968L296.008 40.936V50.008H278.968V54.856L281.608 57.496H295.576V61H279.784ZM278.968 46.648H291.784V41.896L289.144 39.256H281.608L278.968 41.896V46.648Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M305.705 61V35.896H309.929V40.408L314.297 35.896H320.729V40.12H314.489L309.929 44.824V61H305.705Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M331.553 61L326.513 55.96V40.936L331.553 35.896H343.457L348.497 40.936V55.96L343.457 61H331.553ZM333.377 57.64H341.633L344.273 55L344.225 41.896L341.633 39.256H333.377L330.737 41.896V55L333.377 57.64Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.672 119L116.624 83.624H123.392L135.344 119H130.784L127.76 109.784H112.256L109.28 119H104.672ZM113.552 105.944H126.512L120.56 87.752H119.456L113.552 105.944Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142.352 119V93.896H146.576V98.408L150.944 93.896H160.208L165.2 98.936V119H160.976V99.992L158.432 97.256H152.048L146.576 102.824V119H142.352Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M177.956 119L172.964 113.96V108.248L177.956 103.208H190.724V100.088L188.132 97.448H176.228V93.896H189.956L194.948 98.936V119H190.724V115.112L186.836 119H177.956ZM179.828 115.64H185.78L190.724 110.744V106.52L179.828 106.568L177.188 109.16V113L179.828 115.64Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M204.995 119V83.624H209.219V119H204.995Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M223.714 127.976L228.226 117.272H226.45L216.13 93.896H220.786L228.85 113.096H229.954L237.394 93.896H242.002L227.986 127.976H223.714Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M254.202 119L249.786 114.632V97.256H247.146V93.896H249.883L250.939 87.464H254.01V93.896H259.339V97.256H254.01V113.144L256.267 115.496H260.443V119H254.202Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M267.977 91.16V85.496H272.201V91.16H267.977ZM267.977 119V93.896H272.201V119H267.977Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M286.888 119L281.848 113.96V98.936L286.888 93.896H298.359L302.776 98.264V102.248H298.552V99.656L296.151 97.256H288.712L286.072 99.896V112.808L288.712 115.496H302.535V119H286.888Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M311.636 119V115.496H324.932L327.188 113.192V110.168L324.788 107.768H314.852L310.436 103.448V98.36L314.852 93.896H329.012V97.448H316.868L314.66 99.608V102.056L316.964 104.36H326.996L331.412 108.68V114.584L327.044 119H311.636Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTzAppLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TZAppLogo.5bcb80833cb11b5cda2ace0914def631.svg";